// Filters.tsx
import React from "react";
import { TargetMarketplaceFilterSettings } from "./filters_tabs/TargetMarketplaceFilterSettings";
import { SourceMarketplaceFilterSettings } from "./filters_tabs/SourceMarketplaceFilterSettings";
import { useTranslation } from "../../../hooks/useTranslation";
import { TabbedInterface } from "../../../components/layout/tabbed-interface/TabbedInterface";

export const Filters = () => {
  const { translate } = useTranslation("pages.storeSecurity.filters.tabs");

  const tabs = [
    {
      label: "sourceMarketplaceFilterSettings",
      path: "source",
      component: <SourceMarketplaceFilterSettings />,
    },
    {
      label: "targetMarketplaceFilterSettings",
      path: "target",
      component: <TargetMarketplaceFilterSettings />,
    },
  ];

  return (
    <TabbedInterface tabs={tabs} defaultPath="source" translate={translate} />
  );
};
